import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonRow } from '@ionic/angular/standalone';
import { Instruction, QuestionItemType } from 'src/app/services/slip.service';

@Component({
  selector: 'app-ssqw-instructions-slide',
  templateUrl: './ssqw-instructions-slide.component.html',
  styleUrls: ['./ssqw-instructions-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonRow, IonButton]
})
export class SsqwInstructionsSlideComponent {
  public instruction: Instruction;
  @Input()
  public set item(value: QuestionItemType) {
    this.instruction = value as Instruction;
  }
  @Output() ok = new EventEmitter<void>();
}
